import React from 'react';
import { motion } from 'framer-motion';
import FeatureCard from './FeatureCard';

const categories = [
  {
    name: 'AI & Analysis',
    accent: '#8b5cf6',
    features: [
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 2a10 10 0 1 0 10 10h-4a6 6 0 1 1-6-6V2z" /><path d="M12 2v8l4-3-4-5z" /><path d="M12 10l4 3" /><circle cx="12" cy="12" r="2" /></svg>,
        badge: 'Premium',
        title: 'AI Trading Analysis',
        description: 'Upload chart dan dapatkan analisis AI lengkap untuk keputusan trading yang lebih cerdas.',
        benefits: ['Trend Detection', 'Entry & Exit Points', 'Stop Loss Rekomendasi', 'Risk Reward Ratio'],
      },
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 2a10 10 0 1 0 10 10h-4a6 6 0 1 1-6-6V2z" /><path d="M12 2v8l4-3-4-5z" /></svg>,
        badge: 'Premium',
        title: 'Radar Pasar',
        description: 'Pantau pergerakan pasar real-time dengan filter multi-kriteria dan deteksi momentum.',
        benefits: ['Filter Multi-Kriteria', 'Deteksi Momentum', 'Volume Analysis', 'Sentimen Pasar'],
      },
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" /></svg>,
        badge: 'Baru',
        title: 'AI News Summary',
        description: 'Rangkuman berita pasar otomatis dari berbagai sumber terpercaya dengan analisis sentimen.',
        benefits: ['Ringkasan Otomatis', 'Analisis Sentimen', 'Multi-Sumber', 'Notifikasi Berita'],
      },
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="3" width="18" height="18" rx="2" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="9" y1="3" x2="9" y2="21" /></svg>,
        badge: 'Gratis',
        title: 'Stock Screener',
        description: 'Saring saham berdasarkan kriteria fundamental dan teknikal dengan mudah dan cepat.',
        benefits: ['Filter Fundamental', 'Filter Teknikal', 'Screening Real-time', 'Export Data'],
      },
    ],
  },
  {
    name: 'Learning',
    accent: '#0C8F86',
    features: [
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1-2.5-2.5z" /><polyline points="8 2 8 8 11 6 14 8 14 2" /></svg>,
        badge: 'Gratis',
        title: 'Akademi Trading',
        description: 'Belajar dari level dasar hingga mahir dengan materi terstruktur dan studi kasus nyata.',
        benefits: ['Modul Terstruktur', 'Studi Kasus Nyata', 'Akses Seumur Hidup', 'Belajar Mandiri'],
      },
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polygon points="23 7 16 12 23 17 23 7" /><rect x="1" y="5" width="15" height="14" rx="2" ry="2" /></svg>,
        badge: 'Gratis',
        title: 'Video Course',
        description: 'Ratusan video tutorial dari mentor profesional tentang analisis teknikal & fundamental.',
        benefits: ['HD Video Quality', 'Materi Berkala', 'Download Offline', 'Transkrip & Catatan'],
      },
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>,
        badge: 'Gratis',
        title: 'Quiz & Evaluasi',
        description: 'Uji pemahaman Anda dengan quiz interaktif setelah setiap modul pembelajaran.',
        benefits: ['Quiz Interaktif', 'Evaluasi Progress', 'Skor & Peringkat', 'Rekomendasi Ulang'],
      },
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 20h9" /><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" /></svg>,
        badge: 'Premium',
        title: 'Sertifikat',
        description: 'Dapatkan sertifikat resmi setelah menyelesaikan setiap level pembelajaran.',
        benefits: ['Sertifikat Resmi', 'Verifikasi Online', 'Berbagi ke LinkedIn', 'Multi-Level'],
      },
    ],
  },
  {
    name: 'Trading',
    accent: '#58bd7d',
    features: [
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="3" width="20" height="14" rx="2" ry="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" /></svg>,
        badge: 'Gratis',
        title: 'Paper Trading',
        description: 'Latihan trading dengan dana virtual Rp 100jt tanpa risiko kehilangan uang sungguhan.',
        benefits: ['Dana Virtual Rp 100jt', 'Data Real-time', 'Tanpa Risiko', 'Evaluasi Performa'],
      },
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="9" y1="3" x2="9" y2="21" /></svg>,
        badge: 'Gratis',
        title: 'Trading Journal',
        description: 'Catat dan evaluasi setiap keputusan trading Anda untuk meningkatkan konsistensi.',
        benefits: ['Catat Transaksi', 'Screenshot Chart', 'Analisis Loss', 'Laporan Bulanan'],
      },
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M22 12h-4l-3 9L9 3l-3 9H2" /></svg>,
        badge: 'Premium',
        title: 'Portfolio Tracker',
        description: 'Lacak dan monitor portofolio investasi Anda secara real-time dengan dashboard lengkap.',
        benefits: ['Multi Akun', 'P&L Real-time', 'Alokasi Aset', 'Diversifikasi'],
      },
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 20h9" /><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" /></svg>,
        badge: 'Premium',
        title: 'Watchlist',
        description: 'Buat daftar pantauan saham dan crypto favorit dengan notifikasi pergerakan harga.',
        benefits: ['Multi Watchlist', 'Notifikasi Harga', 'Analisis Cepat', 'Sinkronasi Real-time'],
      },
    ],
  },
  {
    name: 'Community',
    accent: '#f59e0b',
    features: [
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>,
        badge: 'Gratis',
        title: 'Komunitas',
        description: 'Bergabung dengan ribuan trader Indonesia untuk diskusi, networking, dan sharing strategi.',
        benefits: ['Grup Diskusi', 'Diskusi Pasar', 'Sharing Strategi', 'Networking'],
      },
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="3" width="20" height="14" rx="2" ry="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" /></svg>,
        badge: 'Premium',
        title: 'Live Webinar',
        description: 'Webinar eksklusif setiap minggu dengan pembahasan pasar, strategi, dan analisis terkini.',
        benefits: ['Webinar Mingguan', 'Tanya Jawab Live', 'Rekaman Tersedia', 'Materi PDF'],
      },
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M8 2v4" /><path d="M16 2v4" /><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M3 10h18" /></svg>,
        badge: 'Premium',
        title: 'Event Eksklusif',
        description: 'Akses ke event trading nasional & internasional, workshop, dan gathering komunitas.',
        benefits: ['Workshop Intensif', 'Meetup Offline', 'Trading Competition', 'Networking Event'],
      },
    ],
  },
  {
    name: 'Productivity',
    accent: '#2e72d2',
    features: [
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>,
        badge: 'Premium',
        title: 'Stock Alert',
        description: 'Notifikasi real-time untuk pergerakan harga saham & crypto yang Anda pantau.',
        benefits: ['Alert Harga', 'Target TP/SL', 'Push Notification', 'Email Alert'],
      },
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>,
        badge: 'Gratis',
        title: 'Economic Calendar',
        description: 'Jadwal rilis data ekonomi global yang mempengaruhi pergerakan pasar.',
        benefits: ['Data Global', 'Dampak Pasar', 'Notifikasi Event', 'Prediksi Konsensus'],
      },
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" /></svg>,
        badge: 'Gratis',
        title: 'Notifikasi',
        description: 'Pemberitahuan pintar untuk aktivitas penting di akun dan pergerakan pasar.',
        benefits: ['Push Notifikasi', 'In-app Notifikasi', 'Kustom Preferensi', 'Ringkasan Harian'],
      },
      {
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="5" y="2" width="14" height="20" rx="2" ry="2" /><line x1="12" y1="18" x2="12.01" y2="18" /></svg>,
        badge: 'Gratis',
        title: 'Mobile App',
        description: 'Akses Tradiora kapan saja, di mana saja melalui aplikasi mobile iOS & Android.',
        benefits: ['iOS & Android', 'Face ID / Touch ID', 'Trading Mobile', 'Sync Multi Device'],
      },
    ],
  },
];

function FeatureCategory() {
  return (
    <section className="feature-category-section">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 60 }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <div className="section-label">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0C8F86" strokeWidth="2.5"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>
              Fitur Lengkap
            </div>
            <h2 style={{ fontSize: 40, fontWeight: 700, color: 'var(--onsurface)', marginBottom: 16, letterSpacing: '-1px' }}>
              Semua Fitur dalam{' '}
              <span style={{ color: '#0C8F86' }}>Satu Platform</span>
            </h2>
            <p style={{ fontSize: 16, color: 'var(--text)', maxWidth: 560, margin: '0 auto', lineHeight: 1.7 }}>
              Dari analisis AI hingga mentoring eksklusif, Tradiora menyediakan semua alat yang Anda butuhkan.
            </p>
          </motion.div>
        </div>

        {categories.map((category, catIdx) => (
          <div key={category.name} style={{ marginBottom: catIdx < categories.length - 1 ? 80 : 0 }}>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4 }}
              style={{ marginBottom: 32 }}
            >
              <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 12,
                padding: '8px 20px 8px 8px',
                borderRadius: 100,
                background: `${category.accent}08`,
                border: `1px solid ${category.accent}15`,
              }}>
                <span style={{
                  width: 36, height: 36, borderRadius: '50%',
                  background: category.accent,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: '#fff', fontSize: 14, fontWeight: 700,
                }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                </span>
                <span style={{ fontSize: 18, fontWeight: 700, color: 'var(--onsurface)' }}>{category.name}</span>
              </div>
            </motion.div>

            <div className="row">
              {category.features.map((feature, featIdx) => (
                <div className="col-xl-3 col-lg-4 col-md-6" key={feature.title} style={{ marginBottom: 24 }}>
                  <FeatureCard {...feature} index={catIdx * 4 + featIdx} />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FeatureCategory;
